<template>
    <v-checkbox @update:modelValue="changeCheckbox" label="Check Formula" />
</template>

<script setup lang="ts">
import { useCalculationStore } from '../../stores/calculationStore';


const calculationStore = useCalculationStore();

function changeCheckbox(value: boolean) {
    if (value) {
        calculationStore.freezeCalculation = 1;
    } else {
        calculationStore.removeFreeze();
    }
}



</script>